module.exports = {"id":"dp1_1l3q3","text":"Search, Browse and Filter Information","instructions":"Which result is generally more relevant to a specific search need?","multiselect":false,"category":"1.1","questionType":"PickOne","random":true,"options":[{"id":"dp1_1l3q3-a1","text":"Matches keywords closely","score":3.7},{"id":"dp1_1l3q3-a2","text":"Appears first always","score":1.3},{"id":"dp1_1l3q3-a3","text":"Has many images","score":1.3}],"groupTitle":"Digital Profiler Knowledge Matrix"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat1.1/l3q3.json
// module id = 929
// module chunks = 41